import { gateway } from "../../../gateway";
import { IEventDeliveryLogsPage, IGetEventDeliveryLogsParams } from "../interfaces";

export const getEventDeliveryLogs = async (params: IGetEventDeliveryLogsParams = {}): Promise<IEventDeliveryLogsPage> => {
  const response = await gateway.get("/event-delivery/logs", {
    params: {
      page: params.page ?? 1,
      pageSize: params.pageSize ?? 10,
      ...(params.source ? { source: params.source } : {}),
    },
  });
  return response?.data?.data;
};
